// prettier-ignore
export default function isValidURL(str) {//NOSONAR
  let url;
  try {
    url = new URL(str);
    return url;
  } catch (_) {
    return false;
  }
}
